import {
  type DetailAdjuntoComunicadoModel,
  type DetailComunicadoColaboradorModel,
  type DetailComunicadoModel,
  type TipoComunicadoEnum,
} from "@api/api";

export type ComunicadoPrevisualizacionData = DetailComunicadoModel | DetailComunicadoColaboradorModel;

export class ComunicadoPrevisualizacionModel {
  Tipo!: TipoComunicadoEnum;
  Asunto!: string;
  Cuerpo!: string;
  Adjuntos!: DetailAdjuntoComunicadoModel[];

  constructor(data?: ComunicadoPrevisualizacionData) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static fromApi(data: ComunicadoPrevisualizacionData): ComunicadoPrevisualizacionModel {
    return new ComunicadoPrevisualizacionModel(data);
  }

  get rutasAdjuntos(): string[] {
    return this.Adjuntos?.map(adjunto => adjunto.Ruta) ?? [];
  }
}
